import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Grid,
  Card,
  CardActionArea,
  CardContent,
  Typography,
  Stack
} from '@mui/material';
import { Assessment as AssessmentIcon, AccountBalance as AccountBalanceIcon, Receipt as ReceiptIcon } from '@mui/icons-material';

const VentasInformes: React.FC = () => {
  const navigate = useNavigate();

  const informes = [
    {
      title: 'Cuentas por Cobrar',
      description: 'Visualiza el saldo pendiente de cobro por cliente.',
      icon: AssessmentIcon,
      path: 'cuentas-cobrar',
      color: '#4caf50',
      bgGradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      iconBg: 'rgba(76, 175, 80, 0.1)'
    },
    {
      title: 'Resumen de Cuenta',
      description: 'Visualiza la composición del saldo con todos los comprobantes del cliente.',
      icon: AccountBalanceIcon,
      path: 'resumen-cuenta',
      color: '#4caf50',
      bgGradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
      iconBg: 'rgba(76, 175, 80, 0.1)'
    },
    {
      title: 'Libro IVA Ventas',
      description: 'Visualiza el registro de IVA de todas las facturas de venta.',
      icon: ReceiptIcon,
      path: 'libro-iva-ventas',
      color: '#4caf50',
      bgGradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
      iconBg: 'rgba(76, 175, 80, 0.1)'
    }
  ];

  return (
    <Box sx={{ p: { xs: 2, sm: 3 }, bgcolor: '#f5f5f5', minHeight: '100vh' }}>
      {/* Tarjeta blanca contenedora principal */}
      <Card 
        sx={{ 
          bgcolor: '#ffffff',
          borderRadius: 3,
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          overflow: 'hidden'
        }}
      >
        <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
          {/* Header con título */}
          <Box sx={{ mb: 4 }}>
            <Typography 
              variant="h4" 
              sx={{ 
                fontWeight: 600,
                color: '#1976d2',
                mb: 1
              }}
            >
              Informes de Ventas
            </Typography>
            <Typography 
              variant="body2" 
              color="text.secondary"
              sx={{ fontSize: '0.95rem' }}
            >
              Selecciona un informe para visualizar información detallada
            </Typography>
          </Box>

          {/* Grid de tarjetas de informes */}
          <Grid container spacing={3}>
            {informes.map((informe) => {
              const IconComponent = informe.icon;
              return (
                <Grid item xs={12} sm={6} md={6} key={informe.path}>
                  <Card
                    sx={{
                      borderRadius: 3,
                      border: '1px solid #e0e0e0',
                      overflow: 'hidden',
                      transition: 'all 0.3s ease',
                      position: 'relative',
                      '&:hover': {
                        transform: 'translateY(-8px)',
                        boxShadow: '0 12px 24px rgba(0,0,0,0.15)',
                        borderColor: informe.color,
                      },
                    }}
                  >
                    <CardActionArea 
                      onClick={() => navigate(informe.path)}
                      sx={{ 
                        p: 0,
                        '&:hover': {
                          '& .MuiCardActionArea-focusHighlight': {
                            opacity: 0,
                          }
                        }
                      }}
                    >
                      <CardContent sx={{ p: 3 }}>
                        <Stack spacing={2}>
                          {/* Icono con fondo de color */}
                          <Box
                            sx={{
                              width: 64,
                              height: 64,
                              borderRadius: 2,
                              bgcolor: informe.iconBg,
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              mb: 1,
                            }}
                          >
                            <IconComponent 
                              sx={{ 
                                fontSize: 36, 
                                color: informe.color 
                              }} 
                            />
                          </Box>

                          {/* Título */}
                          <Typography 
                            variant="h5" 
                            sx={{ 
                              fontWeight: 600,
                              color: '#1a1a1a',
                              mb: 0.5
                            }}
                          >
                            {informe.title}
                          </Typography>

                          {/* Descripción */}
                          <Typography 
                            variant="body2" 
                            color="text.secondary"
                            sx={{ 
                              fontSize: '0.95rem',
                              lineHeight: 1.6
                            }}
                          >
                            {informe.description}
                          </Typography>

                          {/* Indicador de acción */}
                          <Box
                            sx={{
                              mt: 2,
                              display: 'flex',
                              alignItems: 'center',
                              color: informe.color,
                              fontWeight: 500,
                              fontSize: '0.9rem',
                            }}
                          >
                            Ver informe
                            <Box
                              component="span"
                              sx={{
                                ml: 1,
                                transition: 'transform 0.3s ease',
                                display: 'inline-block',
                                '&:hover': {
                                  transform: 'translateX(4px)',
                                }
                              }}
                            >
                              →
                            </Box>
                          </Box>
                        </Stack>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>
              );
            })}
          </Grid>
        </CardContent>
      </Card>
    </Box>
  );
};

export default VentasInformes;
